<template>
    <span v-if="videocallsCount > 0" :class="animateClass" class="notification-badge position-absolute top-0 start-100 translate-middle badge rounded-pill">
        {{ videocallsCount }}
        <span class="visually-hidden">{{ unconfirmedvideocallslabel }}</span>
    </span>
</template>

<script>
    export default {
        props: [
            'startingvideocallscount',
            'unconfirmedvideocallslabel',
            'currentuserid',
            'listentobroadcast'
        ],

        data() {
            return {
                videocallsCount: this.startingvideocallscount ?? 0,
                animateClass: ''
            }
        },

        mounted() {
            this.echoChannelListening();
        },

        methods: {
            echoChannelListening() {
                var _this = this;
                var listenToBroadcast = JSON.parse(this.listentobroadcast);
                _.forEach(listenToBroadcast, function(broadcastChannel) {
                    Echo.private(broadcastChannel)
                        .listen('VideoCallRequestCreated', (e) => {
                            _this.getUnconfirmedVideocallsCount();
                        });
                });

            },

            getUnconfirmedVideocallsCount() {
                var _this = this;
                axios.get('/fornitore/videochiamate/count').then((response) => {
                    var data = response.data;
                    if (data.success) {
                        _this.videocallsCount = data.count;
                        _this.animateBadge();
                    }
                })
            },

            animateBadge() {
                var _this = this;
                _this.animateClass = 'animate';
                setTimeout(function() {
                    _this.animateClass = '';
                }, 6000)
            }
        }
    }
</script>